





































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import ExpenseDebtCustomerTable from "../../../expensecustomer/Form/components/ExpenseDebtCustomerTable/index.vue";
import {ReceiptExpensesPickingListTargetType} from "@/enums/type";
import ExpenseDebtPostOfficeTable
  from "@/modules/receiptsexpenses/expensepostoffice/Form/components/ExpenseDebtPostOfficeTable/index.vue";
import ReceiptDebtCustomerTable
  from "@/modules/receiptsexpenses/receiptcustomer/Form/components/ReceiptDebtCustomerTable/index.vue";
import ReceiptDebtEmployeeTable
  from "@/modules/receiptsexpenses/receiptemployee/Form/components/ReceiptDebtEmployeeTable/index.vue";
import ReceiptDebtPartnerTable
  from "@/modules/receiptsexpenses/receiptpartner/Form/components/ReceiptDebtPartnerTable/index.vue";

@Component({
  name: 'ConfirmReceiptExpense',
  components: {
    ReceiptDebtPartnerTable,
    ReceiptDebtEmployeeTable, ReceiptDebtCustomerTable, ExpenseDebtPostOfficeTable, ExpenseDebtCustomerTable}
})
export default class extends mixins(CommonMixin) {
  @PropSync('visible', { default: false, type: Boolean }) syncVisible!: boolean;
  @Prop() typeDebt!: number;
  @Prop() dataConfirm!: any;
  @Prop() title!: string;
  @Prop({type: Boolean, default: false}) isSaving!: boolean;
  ReceiptExpensesPickingListTargetType = ReceiptExpensesPickingListTargetType;

  get totalMoney() {
    return this.dataConfirm?.totalMoney;
  }

  onConFirm() {
    this.$emit('confirm', true);
  }
}
